import { render, staticRenderFns } from "./BiteActions.vue?vue&type=template&id=6400c600&scoped=true"
import script from "./BiteActions.vue?vue&type=script&lang=js"
export * from "./BiteActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400c600",
  null
  
)

export default component.exports